/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/services/app.tutorial.service.ts.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {AppConfigService} from './app.config.service';
import {AppMobileappService} from './app.mobileapp.service';

/**
 * Zweck: Beschreibt class AppTutorialService und ihren Daten- oder Funktionsvertrag.
 */
@Injectable({providedIn: 'root'})
export class AppTutorialService {

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private http: HttpClient, private cfg: AppConfigService, private asvc: AppMobileappService) {
  }

/**
 * Beschreibt Methode load und ihren Rückgabevertrag.
 */
  load(): Observable<string[]> {
    return this.http.post<string[]>(
      '/tutorials',
      {
        isApp: this.asvc.isApp()
      }
    );
  }

/**
 * Beschreibt Methode setSeen und ihren Rückgabevertrag.
 */
  setSeen(id: string): Observable<boolean> {
    return this.http.post<boolean>(
      '/tutorials/' + id + '/seen',
      {
        isApp: this.asvc.isApp()
      }
    );
  }

/**
 * Beschreibt Methode resetAll und ihren Rückgabevertrag.
 */
  resetAll(): Observable<boolean> {
    return this.http.post<boolean>(
      '/tutorials/reset',
      {
        isApp: this.asvc.isApp()
      }
    );
  }
}
